import { useFeatureFlag } from '@/providers/FeatureFlags';
import useDismissedMessages from '@/providers/Messages/useDismissedMessages';
import XCircle from '@/components/Icons/XCircle';
import { FC } from 'react';

import s from './NoodleIsNowGladeBanner.module.scss';

import Noodle from '../Icons/Noodle';
import Buttons from '../Buttons';

const DISMISS_KEY = 'noodle-is-now-glade';

const NoodleIsNowGladeBanner: FC = () => {
  const canShowGlade = useFeatureFlag('is-glade-dot-ai');
  const { dismissMessage, isMessageDismissed, isInitialized } = useDismissedMessages();

  const isGladeAi = window.location.hostname.includes('app.glade.ai');

  if (!canShowGlade || isMessageDismissed(DISMISS_KEY) || !isInitialized || isGladeAi) return <></>;

  return (
    <div className={s.banner}>
      <div />
      <p className="caption-bold">
        <Noodle width={12} height={12} /> Noodle is now <span>Glade</span>
      </p>
      <Buttons isWrapper onClick={() => dismissMessage(DISMISS_KEY)}>
        <XCircle weight="fill" color="var(--color-gray-50)" />
      </Buttons>
    </div>
  );
};

export default NoodleIsNowGladeBanner;
